export default class LanguageSelectClient
{
    constructor()
    {
        this._selectLanguageUri = '/v1-api-set-language-';
    }

    /**
     * @returns {Promise<Response>}
     */
    selectLanguage(newLanguage)
    {
        return fetch(this._selectLanguageUri + newLanguage, { 'method': 'POST' });
    }
}
